import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { Category } from 'src/app/models/categories-model';
import { ServiceFilter } from 'src/app/models/all-services.model';
import { StoreService } from 'src/app/services/store.service';

@Component({
  selector: 'app-category-chips',
  templateUrl: './category-chips.component.html',
  styleUrls: ['./category-chips.component.scss'],
})
export class CategoryChipsComponent implements OnInit {
  @Input() categories!: Category[];
  @Input() filterConfig!: ServiceFilter;
  @Output() applyCategory = new EventEmitter<string>();
  constructor(
    private storeService:StoreService
  ) {}

  ngOnInit() {
  }
}
